import { render, staticRenderFns } from "./RasmusUserPassword.vue?vue&type=template&id=08431819&"
import script from "./RasmusUserPassword.vue?vue&type=script&lang=ts&"
export * from "./RasmusUserPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports